export class CertificateDownload{
    
    public static Create(content:Uint8Array, filename:string) : void
    {
        let fileURL = window.URL.createObjectURL(new Blob([content], { type: 'application/octet-stream' }) );
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', filename);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
    }
    
}